import React, { useState } from 'react';
import Skeleton from '@material-ui/lab/Skeleton';

const Skltn = () => {

    const [state, setState] = useState([1, 2, 3, 4, 5, 6, 7, 8, 9, 10])

    return (
        <>
            {state.map(info =>
                <div className="lottery skltn-lotterycard">
                    <div className="title">
                        <Skeleton animation="wave" width={200} height={28} />
                    </div>
                    <div className="title status">
                        وضعیت شما : <Skeleton animation="wave" width={100} height={28} />
                    </div>
                    <div className="timestamp active">
                        <div className="time">
                            <Skeleton animation="wave" width={34} height={34} />
                            <span>دقیقه</span>
                        </div>

                        <div className="time">
                            <Skeleton animation="wave" width={34} height={34} />
                            <span>ساعت</span>
                        </div>
                        <div className="time">
                            <Skeleton animation="wave" width={34} height={34} />
                            <span>روز</span>
                        </div>
                    </div>
                    <Skeleton animation="wave" width={100} height={30} />
                </div>
            )}
        </>
    );
}

export default Skltn;